export const INIT_FILTER_FIELDS = {
    studentId: "",
    penaltyStartDate: -1
};
export const RECORDS_BY_PAGE = 10;
export const HEADERS_TABLE_LIST = [
    { title: "Código" },
    { title: "Nombre(s) y Apellido(s)" }, 
    { title: "Inicia" }, 
    { title: "Finaliza" },
    { title: "" }
];
export const TAB_KEYS = {
    CURRENT: "current",
    EXPIRED: "expired",
    REMOVED: "removed"
}
export const TAB_VALUES = {
    [TAB_KEYS.CURRENT]: 0,
    [TAB_KEYS.EXPIRED]: 1,
    [TAB_KEYS.REMOVED]: 2
};
export const TAB_KEYS_BY_VALUE = {
    [TAB_VALUES[TAB_KEYS.CURRENT]]: TAB_KEYS.CURRENT,
    [TAB_VALUES[TAB_KEYS.EXPIRED]]: TAB_KEYS.EXPIRED,
    [TAB_VALUES[TAB_KEYS.REMOVED]]: TAB_KEYS.REMOVED
};
export const INITIAL_TITLE_TAB_VIEWS = Object.fromEntries(Object.values(TAB_KEYS).map(key => [key, 0]));
export const DEFAULT_PARAMS_IN_FILL_PENALTIES = { 
    messageForToast: null, 
    noFill: false,
    penaltyId: 0
};